import { lazy } from "react";

/**
 * @description Lazily load the `UserProfile` component
 *
 * {@link https://react.dev/reference/react/lazy#suspense-for-code-splitting 🔗 Lazy Loading components with Suspense}
 */
export const UserProfileAsync = lazy(async function () {
  return import("./UserProfile").then((module) => ({ default: module.UserProfile }));
});
